/**
 * Tipos de tipos de ativos
 */
export enum AssetTypeType {
  MOVABLE = "MOVABLE",
  IMMOVABLE = "IMMOVABLE",
}

export const AssetTypeTypeLabels: Record<AssetTypeType, string> = {
  [AssetTypeType.MOVABLE]: "Móvel",
  [AssetTypeType.IMMOVABLE]: "Imóvel",
};

export enum AssetTypeFieldType {
  STRING = "STRING",
  NUMBER = "NUMBER",
  DATE = "DATE",
  MONEY = "MONEY",
  UPLOAD = "UPLOAD",
  SELECT = "SELECT",
}

export const AssetTypeFieldTypeLabels: Record<AssetTypeFieldType, string> = {
  [AssetTypeFieldType.STRING]: "Alfanumérico",
  [AssetTypeFieldType.NUMBER]: "Número",
  [AssetTypeFieldType.MONEY]: "Valor Monetário",
  [AssetTypeFieldType.DATE]: "Data",
  [AssetTypeFieldType.UPLOAD]: "Upload",
  [AssetTypeFieldType.SELECT]: "Seleção",
};

export interface AssetTypeFieldOption {
  value: string;
  key?: string;
}

export interface AssetTypeFieldData {
  _id: string;
  name?: string;
  type?: AssetTypeFieldType;
  required?: boolean;
  options?: string[];
}

export interface AssetTypeOutputDTO {
  _id?: string;
  name?: string;
  description?: string;
  type?: "MOVABLE" | "IMMOVABLE";
  data?: AssetTypeFieldData[];
  createdAt?: Date;
  updatedAt?: Date;
}
